/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Hidevalue1Inputs */

const en_entity_hidevalue1 = /** @type {(inputs: Entity_Hidevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Value`)
};

const de_entity_hidevalue1 = /** @type {(inputs: Entity_Hidevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide Value" |
*
* @param {Entity_Hidevalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_hidevalue1 = /** @type {((inputs?: Entity_Hidevalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Hidevalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_hidevalue1(inputs)
	return de_entity_hidevalue1(inputs)
});
export { entity_hidevalue1 as "entity_hideValue" }